<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Cotizaciones</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <div class="input-group-append">
                <CotizacionesModelAddComponent />
              </div>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refrescar</a>
            </div>
            <div class="col-sm-6">
              <form @submit="filterData" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Buscar #"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                >
                  <option  value>Todos</option>
                  <option value="A">En proceso</option>
                  <option value="B">Cerrado</option>
                  <option value="9">Anulado</option>
                </select>
              </form>
            </div>
          </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="row">
          <div class="col-md-12">
            <CotizacionesTableComponent />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import CotizacionesModelAddComponent from "@/components/compras/cotizaciones/CotizacionesModelAddComponent";
import CotizacionesService from "@/services/compras/CotizacionesService";
import CotizacionesTableComponent from "@/components/compras/cotizaciones/CotizacionesTableComponent";

export default {
  components: {
    PaginationComponent,
    CotizacionesModelAddComponent,
    CotizacionesTableComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: []
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    filterData(e) {
      e.preventDefault();
      this.$data.currentPage = 1;
      this.$store.dispatch("cotizaciones/fetch", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.$store.dispatch("cotizaciones/fetch", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext
      });
    },
  }
};
</script>
